import { TopicAppearanceApi, topicsApi } from "api/topics/topicsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useTopicAppearances = (topicId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.TOPIC_APPEARANCES(topicId),
    queryFn: () => topicsApi.featchAppearances(topicId),
  });
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.TOPIC_APPEARANCES(topicId),
    });
  };

  return { invalidate, isLoading, appearances: data?.data ?? ({} as TopicAppearanceApi) };
};
